import wixAnimations from 'wix-animations';
import wixWindow from 'wix-window';
import wixLocation from 'wix-location';
import { fireBIEvent } from 'public/bi-events.js';

// ...
let baseUrl = wixLocation.baseUrl;
let formFactor = wixWindow.formFactor;

let timelineMobile = wixAnimations.timeline();
let timelineMobileMenu = wixAnimations.timeline();
let timelineMobileIconSpin = wixAnimations.timeline();
let timelineMobileBar = wixAnimations.timeline();
let timelineMobileBarSpin = wixAnimations.timeline({
    "repeat": 1,
    "yoyo": true
});
let timelineMobileSticky = wixAnimations.timeline();
let timelinePurpleLastFoldMobile = wixAnimations.timeline({
    "repeat": -1,
    "repeatDelay": 150,
    "yoyo": true
});
let yScroll
let yScrollMobile
let scrollYCheck
let scrollYCheckBarPoints
let scrollYCheckBottom
let scrollYBar = false

$w.onReady(function () {
    // console.log($w("#columnStripVideoHeader").background.src)
    onLoad()
});

function onLoad() {
    /// BI EVENTS
    if (formFactor !== "Mobile") {
        $w('#boxGetOloHeader').onClick(() => {
            fireBiEventData('Get_olo_header')
        })
        $w('#boxGetOloCta').onClick(() => {
            fireBiEventData('Get_olo_cta')
        })
        $w('#boxMenuCta').onClick(() => {
            fireBiEventData('Menu_cta')
        })
        $w('#boxAddLocationCta').onClick(() => {
            fireBiEventData('Add_location_cta')
        })
        $w('#boxCreateCouponCta').onClick(() => {
            fireBiEventData('Create_coupon_cta')
        })
        $w('#boxLoyaltyCta').onClick(() => {
            fireBiEventData('Loyalty_cta')
        })
        $w('#boxTipsCta').onClick(() => {
            fireBiEventData('Tips_cta')
        })
        $w('#boxPaymentsCta').onClick(() => {
            fireBiEventData('Payments_cta')
        })
        // $w('#boxAutomatedConCta').onClick(() => {
        //     fireBiEventData('Automated_con_cta')
        // })
        $w('#boxBottomFoldCta').onClick(() => {
            fireBiEventData('Bottom_fold_cta')
        })
    }

    $w('#boxDinebywixCta').onClick(() => {
        fireBiEventData('Dinebywix_cta')
    })
    $w('#boxBrandedAppCta').onClick(() => {
        fireBiEventData('Branded_app_cta')
    })
    $w('#boxWixOwnerAppCta').onClick(() => {
        fireBiEventData('Wix_owner_app_cta')
    })

    function fireBiEventData(btnName) {
        console.log("btn-name: " + btnName)
        
        const biFields = {
            button_name: btnName,
            topic: 'online ordering LP',
            is_valid: true,
            url: baseUrl
        }
        fireBIEvent(19, 703, biFields);
    }

    ////
    resetMultiboxes("all")
    scrollEffects()

    if (formFactor === "Mobile") { 
        $w("#columnStripVideoHeader").background.src = "wix:video://v1/0784b1_f4c774a56efb4af386c774af6f956b80/_#posterUri=0784b1_f4c774a56efb4af386c774af6f956b80f000.jpg&posterWidth=522&posterHeight=1080"
    } else {
        setResponsive()
        setStickyBox()
        setFormAnimation()
    }

}

function getScrollY(fold) {
    wixWindow.getBoundingRect()
        .then((windowSizeInfo) => {
            if (fold === "inner") {
                scrollYCheck = windowSizeInfo.scroll.y;
            }
            if (fold === "bottom") {
                scrollYCheckBottom = windowSizeInfo.scroll.y;
                // console.log("scrollYCheckBottom: " + scrollYCheckBottom)
            }
            if (fold === "barPoints") {
                scrollYCheckBarPoints = windowSizeInfo.scroll.y;
            }
        });
}

function scrollEffects() {
    let yScrollStopCoorBoolBottom = false
    let yScrollStopCoorBool = false

    const boxBar = $w("#boxBar");
    const boxBarSpin = $w("#boxBarSpin");

    if (formFactor !== "Mobile") {
        //// fold 1
        let timelineArrow = wixAnimations.timeline({
            "repeat": -1,
            "yoyo": true
        });

        const fold1Arrow = $w("#fold1Arrow");

        timelineArrow
            .add(
                fold1Arrow, {
                    "x": -10,
                    "y": 10,
                    "easing": "easeInOutCubic",
                    "duration": 450
                },
            )
            .play();

        /// fold 1 multiboxes

        $w("#boxAllMultiboxes").onMouseOut((event) => {
            resetMultiboxes("all")
        });
        //////
        $w("#stateboxHover1").onMouseIn((event) => {
            resetMultiboxes(0)
            $w("#stateboxHover1").changeState("hover1")
        });
        $w("#stateboxHover2").onMouseIn((event) => {
            resetMultiboxes(1)
            $w("#stateboxHover2").changeState("hover2")
        });
        $w("#stateboxHover3").onMouseIn((event) => {
            resetMultiboxes(2)
            $w("#stateboxHover3").changeState("hover3")
        });
        $w("#stateboxHover4").onMouseIn((event) => {
            resetMultiboxes(3)
            $w("#stateboxHover4").changeState("hover4")
        });
        $w("#stateboxHover5").onMouseIn((event) => {
            resetMultiboxes(4)
            $w("#stateboxHover5").changeState("hover5")
        });

        ///
        let countAmount = 0
        setInterval(function () {
            amountFillWhite()
            if (countAmount !== 3) {
                countAmount++
            } else {
                countAmount = 0
            }
            if (countAmount === 0) {
                $w("#boxAmount1").style.backgroundColor = "#D0D0D0"
            }
            if (countAmount === 1) {
                $w("#boxAmount2").style.backgroundColor = "#D0D0D0"
            }
            if (countAmount === 2) {
                $w("#boxAmount3").style.backgroundColor = "#D0D0D0"
            }
            if (countAmount === 3) {
                $w("#boxAmount4").style.backgroundColor = "#D0D0D0"
            }

        }, 1000)

        ///////////////

        const boxMobile = $w("#boxMobile");
        timelineMobileSticky
            .add(
                boxMobile, {
                    "y": 1360,
                    "duration": 0,
                },
            )
            .play();

        $w("#boxStartMobileScroll").onViewportLeave((event) => {
            getScrollY("inner")
            yScrollStopCoorBool = true
        });
        $w("#boxStartMobileScroll").onViewportEnter((event) => {
            $w("#boxMobile").show()
            yScrollStopCoorBool = false
        });
        // un pin bottom
        $w("#columnStripBottom").onViewportEnter((event) => {
            getScrollY("bottom")
            yScrollStopCoorBool = true
        });
        $w("#columnStripCard").onViewportEnter((event) => {});
        $w("#columnStripBarPoints").onViewportEnter((event) => {
            getScrollY("barPoints")
        });

        ////
        $w('#customElementScroll').on('coor', (event) => {
            yScroll = event.detail.y
            // console.log(yScroll)
            iconSpinAnim(yScroll)
            ////
            if (yScroll > 8330) {
                yScrollStopCoorBoolBottom = true
            } else {
                yScrollStopCoorBoolBottom = false
            }

            ////

            if (yScroll > 1500) {
                setMaps(1)
            }
            if (yScroll > 3300) {
                setMaps(2)
            }
            if (yScroll > 3500) {
                setMaps(3)
            }

            ////

            let slowerYBar = yScroll - scrollYCheckBarPoints - 820
            // console.log("slowerYBar: " + slowerYBar)
            barGrow(slowerYBar, 300, 400)

            ////
            let slowerY = yScroll * 0.7
            const boxMobileScrollY = $w("#boxMobileScrollY");

            if (yScrollStopCoorBool && yScroll - scrollYCheck > 0) {
                if (!yScrollStopCoorBoolBottom) {
                    timelineMobile
                        .add(
                            boxMobileScrollY, {
                                "y": -slowerY + scrollYCheck - 405,
                                "duration": 0,
                                "easing": "easeLinear"
                            },
                        )
                        .play();
                }

            } else if (yScroll - scrollYCheck > 0) {
                timelineMobile
                    .add(
                        boxMobileScrollY, {
                            "y": 0,
                            "duration": 0,
                            "easing": "easeLinear"
                        },
                    )
                    .play();
            }
            ///

            if (!yScrollStopCoorBool) {
                const boxMobile = $w("#boxMobile");
                timelineMobileSticky
                    .add(
                        boxMobile, {
                            "y": -yScroll + 1360,
                            "easing": "easeLinear",
                            "duration": 0,
                        },
                    )
                    .play();
            }
            if (yScrollStopCoorBoolBottom) {
                const boxMobile = $w("#boxMobile");
                timelineMobileSticky
                    .add(
                        boxMobile, {
                            "y": -yScroll + 8260,
                            "easing": "easeLinear",
                            "duration": 0,
                        },
                    )
                    .play();
            }

        });

    } else {
        ///// MOBILE CODE
        $w("#buttonDineByWix").link = "https://1ov5b.app.link/mzhAyfJvefb"
        $w("#buttonBrandedApp").link = "https://www.wix.com/app-builder"
        $w("#buttonWixOwnerApp").link = "https://vgal2.app.link/rFLFZNruJdb"
        ///
        let countAmount = 0
        setInterval(function () {
            amountFillWhite()
            if (countAmount !== 3) {
                countAmount++
            } else {
                countAmount = 0
            }
            if (countAmount === 0) {
                $w("#boxAmountMobile1").style.backgroundColor = "#D0D0D0"
            }
            if (countAmount === 1) {
                $w("#boxAmountMobile2").style.backgroundColor = "#D0D0D0"
            }
            if (countAmount === 2) {
                $w("#boxAmountMobile3").style.backgroundColor = "#D0D0D0"
            }
            if (countAmount === 3) {
                $w("#boxAmountMobile4").style.backgroundColor = "#D0D0D0"
            }

        }, 1000)

        ////
        $w("#mobileBoxBar").onViewportEnter((event) => {
            scrollYBar = true
        });

        const mobileBoxPurpleLastFold = $w("#mobileBoxPurpleLastFold");

        timelinePurpleLastFoldMobile
            .add(
                mobileBoxPurpleLastFold, {
                    "opacity": 0,
                    "duration": 700,
                    "easing": "easeInOutCubic"
                },
            )
            .play();
        ////
        $w('#mobileCustomElementScroll').on('coor', (event) => {
            yScrollMobile = event.detail.y
            console.log("yScrollMobile: " + yScrollMobile)

            ////
            const mobileBoxScrollMenu = $w("#mobileBoxScrollMenu");
            let yScrollMobileMenu = yScrollMobile - 1450

            if (yScrollMobile > 1450) {
                timelineMobileMenu
                    .add(
                        mobileBoxScrollMenu, {
                            "y": -yScrollMobileMenu * 0.3,
                            "duration": 0,
                            "easing": "easeLinear"
                        },
                    )
                    .play();
            }
            ////

            if (yScrollMobile > 200) {
                setMaps(1)
            }
            if (yScrollMobile > 2650) {
                setMaps(2)
            }
            if (yScrollMobile > 2800) {
                setMaps(3)
            }

            ////
            iconSpinAnim(yScrollMobile)

            let slowerYBar = yScrollMobile - 4520
            // console.log("slowerYBar: " + slowerYBar)
            barGrow(slowerYBar, 150, 300)

        });
    }

    function amountFillWhite() {
        if (formFactor !== "Mobile") {
            $w("#boxAmount1").style.backgroundColor = "#fff"
            $w("#boxAmount2").style.backgroundColor = "#fff"
            $w("#boxAmount3").style.backgroundColor = "#fff"
            $w("#boxAmount4").style.backgroundColor = "#fff"
        } else {
            $w("#boxAmountMobile1").style.backgroundColor = "#fff"
            $w("#boxAmountMobile2").style.backgroundColor = "#fff"
            $w("#boxAmountMobile3").style.backgroundColor = "#fff"
            $w("#boxAmountMobile4").style.backgroundColor = "#fff"
        }

    }

    ////
    function barGrow(y, ySpin, yMove) {
        if (scrollYBar && y > ySpin) {
            timelineMobileBarSpin
                .add(
                    boxBarSpin, {
                        "rotate": 360,
                        "duration": 2800,
                        "easing": "easeInOutQuint"
                    },
                )
                .play();
        }

        if (scrollYBar && y < yMove) {
            timelineMobileBar
                .add(
                    boxBar, {
                        "x": y,
                        "duration": 0,
                    },
                )
                .play();
        }
    }
    ////////
    function iconSpinAnim(yScrollVal) {
        const iconSpin = $w("#iconSpin");
        timelineMobileIconSpin
            .add(
                iconSpin, {
                    "rotate": yScrollVal,
                    "duration": 10,
                },
            )
            .play();

    }

    /// maps
    $w("#datasetMaps").getItems(0, 3)
        .then((result) => {
            itemsMaps = result.items;
            setMaps()
        })
        .catch((err) => {
            let errMsg = err.message;
            let errCode = err.code;
        });

}

function setFormAnimation() {
    let cardNum = "0103 0500 0408 0200"
    let cardDate = "10/24"
    let cardPin = "493"
    let cardFullName = " Ben Anderson"
    ///
    $w("#columnStripCard").onViewportEnter((event) => {
        $w("#textFormCardNum").hide()
        $w("#textFormCardNumPlace").show()
        $w("#textFormDate").hide()
        $w("#textFormDatePlace").show()
        $w("#textFormPin").hide()
        $w("#textFormPinPlace").show()
        $w("#textFormFullName").hide()
        $w("#textFormFullNamePlace").show()

        setTimeout(function () {
            setTimeout(function () {
                cardNumRun()
            }, 50);
            setTimeout(function () {
                cardDateRun()
            }, 2200);
            setTimeout(function () {
                cardPinRun()
            }, 2900);
            setTimeout(function () {
                cardFullNameRun()
            }, 3600);
        }, 1500);
    });

    ////

    function cardNumRun() {
        $w("#textFormCardNum").text = ""
        $w("#textFormCardNum").show()
        $w("#textFormCardNumPlace").hide()
        let cardNumRunCount = 0
        const myIntervalcardNum = setInterval(cardNumRunInter, 100);
        let cardNumFill = ""

        function cardNumRunInter() {
            if (cardNumRunCount < cardNum.length) {
                cardNumFill += cardNum[cardNumRunCount]
                $w("#textFormCardNum").text = cardNumFill
                cardNumRunCount++
            } else {
                clearInterval(myIntervalcardNum);
            }
        }

    }

    function cardDateRun() {
        $w("#textFormDate").text = ""
        $w("#textFormDate").show()
        $w("#textFormDatePlace").hide()
        let cardDateRunCount = 0
        const myIntervalcardDate = setInterval(cardDateRunInter, 100);
        let cardDateFill = ""

        function cardDateRunInter() {
            if (cardDateRunCount < cardDate.length) {
                cardDateFill += cardDate[cardDateRunCount]
                $w("#textFormDate").text = cardDateFill
                cardDateRunCount++
            } else {
                clearInterval(myIntervalcardDate);
            }
        }

    }

    function cardPinRun() {
        $w("#textFormPin").text = ""
        $w("#textFormPin").show()
        $w("#textFormPinPlace").hide()
        let cardPinRunCount = 0
        const myIntervalcardPin = setInterval(cardPinRunInter, 100);
        let cardPinFill = ""

        function cardPinRunInter() {
            if (cardPinRunCount < cardPin.length) {
                cardPinFill += cardPin[cardPinRunCount]
                $w("#textFormPin").text = cardPinFill
                cardPinRunCount++
            } else {
                clearInterval(myIntervalcardPin);
            }
        }

    }

    function cardFullNameRun() {
        $w("#textFormFullName").text = ""
        $w("#textFormFullName").show()
        $w("#textFormFullNamePlace").hide()
        let cardFullNameRunCount = 0
        const myIntervalcardFullName = setInterval(cardFullNameRunInter, 100);
        let cardFullNameFill = ""

        function cardFullNameRunInter() {
            if (cardFullNameRunCount < cardFullName.length) {
                cardFullNameFill += cardFullName[cardFullNameRunCount]
                $w("#textFormFullName").text = cardFullNameFill
                cardFullNameRunCount++
            } else {
                clearInterval(myIntervalcardFullName);
            }
        }
    }
}

function resetMultiboxes(index) {
    if (index !== 0) {
        $w("#stateboxHover1").changeState("reg1")
    }
    if (index !== 1) {
        $w("#stateboxHover2").changeState("reg2")
    }
    if (index !== 2) {
        $w("#stateboxHover3").changeState("reg3")
    }
    if (index !== 3) {
        $w("#stateboxHover4").changeState("reg4")
    }
    if (index !== 4) {
        $w("#stateboxHover5").changeState("reg5")
    }
}

let itemsMaps

function setMaps(index) {
    let labelMap1
    let labelMap2
    let labelMap3

    if (formFactor !== "Mobile") {
        labelMap1 = $w("#textMap1").text
        labelMap2 = $w("#textMap2").text
        labelMap3 = $w("#textMap3").text
    } else {
        labelMap1 = $w("#textMapMob1").text
        labelMap2 = $w("#textMapMob2").text
        labelMap3 = $w("#textMapMob3").text
    }

    function mapNum1() {
        resetAllStyle()
        if (formFactor !== "Mobile") {
            $w("#columnMap").background.src = itemsMaps[0].map
            $w("#textMapCheck1").show()
            $w("#textMapSelected").text = labelMap1
            $w("#textMap1").html = `<p class="font_6" style="font-size:13px;"><span style="color:#7C1034;"><span style="font-family:madefor-text-bold,helveticaneuew01-65medi,helveticaneuew02-65medi,helveticaneuew10-65medi,sans-serif;">${labelMap1}</span></span></p>`
        } else {
            $w("#mobileImageMap").src = itemsMaps[0].mapMobile
            $w("#textMapCheckMob1").show()
            $w("#textMapSelectedMob").text = labelMap1
            $w("#textMapMob1").html = `<p class="font_6" style="font-size:13px;"><span style="color:#7C1034;"><span style="font-family:madefor-text-bold,helveticaneuew01-65medi,helveticaneuew02-65medi,helveticaneuew10-65medi,sans-serif;">${labelMap1}</span></span></p>`
        }
    }

    function mapNum2() {
        resetAllStyle()
        if (formFactor !== "Mobile") {
            $w("#columnMap").background.src = itemsMaps[1].map
            $w("#textMapCheck2").show()
            $w("#textMapSelected").text = labelMap2
            $w("#textMap2").html = `<p class="font_6" style="font-size:13px;"><span style="color:#7C1034;"><span style="font-family:madefor-text-bold,helveticaneuew01-65medi,helveticaneuew02-65medi,helveticaneuew10-65medi,sans-serif;">${labelMap2}</span></span></p>`
        } else {
            $w("#mobileImageMap").src = itemsMaps[1].mapMobile
            $w("#textMapCheckMob2").show()
            $w("#textMapSelectedMob").text = labelMap2
            $w("#textMapMob2").html = `<p class="font_6" style="font-size:13px;"><span style="color:#7C1034;"><span style="font-family:madefor-text-bold,helveticaneuew01-65medi,helveticaneuew02-65medi,helveticaneuew10-65medi,sans-serif;">${labelMap2}</span></span></p>`
        }
    }

    function mapNum3() {
        resetAllStyle()
        if (formFactor !== "Mobile") {
            $w("#columnMap").background.src = itemsMaps[2].map
            $w("#textMapCheck3").show()
            $w("#textMapSelected").text = labelMap3
            $w("#textMap3").html = `<p class="font_6" style="font-size:13px;"><span style="color:#7C1034;"><span style="font-family:madefor-text-bold,helveticaneuew01-65medi,helveticaneuew02-65medi,helveticaneuew10-65medi,sans-serif;">${labelMap3}</span></span></p>`
        } else {
            $w("#mobileImageMap").src = itemsMaps[2].mapMobile
            $w("#textMapCheckMob3").show()
            $w("#textMapSelectedMob").text = labelMap3
            $w("#textMapMob3").html = `<p class="font_6" style="font-size:13px;"><span style="color:#7C1034;"><span style="font-family:madefor-text-bold,helveticaneuew01-65medi,helveticaneuew02-65medi,helveticaneuew10-65medi,sans-serif;">${labelMap3}</span></span></p>`
        }
    }

    // $w("#boxMap1").onClick((event) => {
    //     mapNum1()
    // });
    // $w("#boxMap2").onClick((event) => {
    //     mapNum2()
    // });
    // $w("#boxMap3").onClick((event) => {
    //     mapNum3()
    // });

    if (index === 1) {
        mapNum1()
    }
    if (index === 2) {
        mapNum2()
    }
    if (index === 3) {
        mapNum3()
    }

    function resetAllStyle() {
        if (formFactor !== "Mobile") {
            $w("#textMapCheck1").hide()
            $w("#textMapCheck2").hide()
            $w("#textMapCheck3").hide()
            $w("#textMap1").html = `<p class="font_6" style="font-size:13px;"><span style="font-family:madefor-text,helveticaneuew01-45ligh,helveticaneuew02-45ligh,helveticaneuew10-45ligh,sans-serif;">${labelMap1}</span></p>`
            $w("#textMap2").html = `<p class="font_6" style="font-size:13px;"><span style="font-family:madefor-text,helveticaneuew01-45ligh,helveticaneuew02-45ligh,helveticaneuew10-45ligh,sans-serif;">${labelMap2}</span></p>`
            $w("#textMap3").html = `<p class="font_6" style="font-size:13px;"><span style="font-family:madefor-text,helveticaneuew01-45ligh,helveticaneuew02-45ligh,helveticaneuew10-45ligh,sans-serif;">${labelMap3}</span></p>`
        } else {
            $w("#textMapCheckMob1").hide()
            $w("#textMapCheckMob2").hide()
            $w("#textMapCheckMob3").hide()
            $w("#textMapMob1").html = `<p class="font_6" style="font-size:13px;"><span style="font-family:madefor-text,helveticaneuew01-45ligh,helveticaneuew02-45ligh,helveticaneuew10-45ligh,sans-serif;">${labelMap1}</span></p>`
            $w("#textMapMob2").html = `<p class="font_6" style="font-size:13px;"><span style="font-family:madefor-text,helveticaneuew01-45ligh,helveticaneuew02-45ligh,helveticaneuew10-45ligh,sans-serif;">${labelMap2}</span></p>`
            $w("#textMapMob3").html = `<p class="font_6" style="font-size:13px;"><span style="font-family:madefor-text,helveticaneuew01-45ligh,helveticaneuew02-45ligh,helveticaneuew10-45ligh,sans-serif;">${labelMap3}</span></p>`

        }
    }
}

function setStickyBox() {
    $w("#boxIndicaatorFold1").onViewportEnter((event) => {
        setStickyBoxBackgroundShadow("Left")
        $w("#slideshowBackground").changeSlide(0)
    });
    $w("#boxIndicaatorFold1").onViewportLeave((event) => {
        setStickyBoxBackgroundShadow("Right")
        $w("#slideshowBackground").changeSlide(1)
    });
    $w("#boxIndicaatorFold5").onViewportEnter((event) => {
        setStickyBoxBackgroundShadow("Right")
        scrollYBar = true
    });
    $w("#columnStripFold3").onViewportEnter((event) => {
        setStickyBoxBackgroundShadow("Left")
    });
    $w("#columnStripFold4").onViewportEnter((event) => {
        setStickyBoxBackgroundShadow("Right")
    });
    $w("#columnStripBarPoints").onViewportEnter((event) => {
        setStickyBoxBackgroundShadow("Left")
    });
    $w("#columnStripFold6").onViewportEnter((event) => {
        setStickyBoxBackgroundShadow("Right")
    });
    $w("#columnStripCard").onViewportEnter((event) => {
        setStickyBoxBackgroundShadow("Left")
    });
    $w("#columnStripFold8").onViewportEnter((event) => {
        setStickyBoxBackgroundShadow("Right")
    });

    /// last fold toggle interval
    let lastFoldIntervalVal
    let lastFoldIndex = 1

    function lastFoldInterval() {
        if (lastFoldIndex === 1) {
            lastFoldIndex = 2
            $w("#slideshowBackground").changeSlide(2)
        } else {
            lastFoldIndex = 1
            $w("#slideshowBackground").changeSlide(1)
        }

    }

    $w("#boxAnchorLastFold").onViewportEnter((event) => {
        lastFoldIntervalVal = setInterval(lastFoldInterval, 700);
    });
    $w("#boxAnchorLastFold").onViewportLeave((event) => {
        clearInterval(lastFoldIntervalVal);
        $w("#slideshowBackground").changeSlide(1)
        setTimeout(function () {
            $w("#slideshowBackground").changeSlide(1)
        }, 1200);
    });

    function setStickyBoxBackgroundShadow(side) {
        let fadeOptions = {
            "duration": 300,
        };

        if (side === "Left") {
            $w("#slideshowLeft").show("fade", fadeOptions)
            $w("#slideshowRight").hide("fade", fadeOptions)
        } else {
            $w("#slideshowLeft").hide("fade", fadeOptions)
            $w("#slideshowRight").show("fade", fadeOptions)
        }
    }
}

// Responsive Text Function - Do Not Edit

function setResponsive() {
    if (wixWindow.formFactor === "Desktop") {
        let fontSize = 2
        makeResponsive("#textTitle1", "h1", 3.1, "#fff", 1.1, null, 43);
        makeResponsive("#textTitle3", "h3", fontSize, "#000", 1.3, null, 28);
        makeResponsive("#textTitle4", "h3", fontSize, "#000", 1.3, null, 28);
        makeResponsive("#textTitle5", "h3", fontSize, "#000", 1.3, null, 28);
        makeResponsive("#textTitle6", "h3", fontSize, "#000", 1.3, null, 28);
        makeResponsive("#textTitle7", "h3", fontSize, "#000", 1.3, null, 30);
        makeResponsive("#textTitle8", "h3", fontSize, "#000", 1.3, null, 24);
        makeResponsive("#textTitle9", "h3", fontSize, "#000", 1.3, null, 28);
        makeResponsive("#textTitle10", "h3", fontSize, "#000", 1.3, null, 28);
    }
}

function makeResponsive(elementId, textTheme, fontSize, fontColor, lineHeight, charSpacing, width) {
    let style = "font-size:" + fontSize + "vw;color:" + fontColor + ";line-height:" + lineHeight + ";letter-spacing:" + charSpacing + "vw;width:" + width + "vw";
    $w(elementId).html = "<" + textTheme + " style=" + style + ">" + $w(elementId).text + "</" + textTheme + ">"
}